export const introduction =
  'Erlandson Trade avser att bli heltäckande inom plywood, säväl vad avser olika träslag som storlekar (hel- och kvartsskivor) och tjocklekar. För närvarande har vi följande kvaliteter på lager: [Helskiva = 2440x1220 mm, Kvartsskiva = 1220x610 mm]'

export const teakPlywood = {
  header: 'Teakplywood',
  products: [
    '1-SIDIG HEL- och KVARTSSKIVA (4, 6, 9 och 12 mm)',
    '2-SIDIG HEL- och KVARTSSKIVA (6, 9, 12 och 15 mm)',
  ],
}

export const mahognyPlywood = {
  header: 'Mahognyplywood',
  meranti: 'Meranti (Luanaplywood)',
  merantiProducts: ['1-SIDIG HEL*- och KVARTSSKIVA (4, 6*, 9*, 12, 15* och 18 mm)'],
  khaya: 'Khaya',
  khayaProducts: [
    '1-SIDIG HEL- och KVARTSSKIVA (4 mm)',
    '2-SIDIG HEL- och KVARTSSKIVA (6, 13 och 16 mm)',
  ],
}

export const deckPlywood = {
  header: 'Däcksplywood',
  products: ['1-SIDIG HEL*- och KVARTSSKIVA (6, 12, 15 och 18* mm)'],
  additionalInfo:
    'Däcksplywoodens randad av ömsom teak- (40 mm) och ömsom svart raminfanér (4 mm).',
}

export const durkPlywood = {
  header: 'Durkplywood',
  products: ['1-SIDIG HEL*- och KVARTSSKIVA (6, 12, 15 och 18* mm)'],
  additionalInfo: 'Durkplywoodens randad av ömsom teak- (40 mm) och ömsom vit kotofanér (4 mm).',
}

export const glue = {
  header: 'Lim',
  body:
    'Ovan plywood är WBP-limmad, vilket innebär att den är limmad med ett vattenbeständigt lim. Själva limmet tål därmed vatten, men träet i sig är ändå mottagligt för väta. Därför bör plywood som ska användas utomhus eller i fuktig miljö åtminstone behandlas med en bra träolja, men helst lackas.Speciellt viktigt är att försegla (lacka) plywoodens kanter.',
}

export const cherryPlywood = {
  header: 'Körsbärsplywood',
  products: ['1-SIDIG HEL- och KVARTSSKIVA (4 mm)'],
}

export const oakPlywood = {
  header: 'Ekplywood',
  products: [
    '1-SIDIG HEL- och KVARTSSKIVA (4 mm)',
    '2-SIDIG HEL- och KVARTSSKIVA (6, 9 och 12 mm)',
  ],
}

export const beechPlywood = {
  header: 'Bokplywood',
  products: ['1-SIDIG HEL- och KVARTSSKIVA (4 mm)'],
}

export const walnutPlywood = {
  header: 'Valnötsplywood',
  products: ['1-SIDIG HEL- och KVARTSSKIVA (4 mm)'],
}
